module.exports = __webpack_public_path__ + "2e8d8c839d6780b589657795e5383420.svg";